import {checkRequiredParameters, createCustomFetch} from './utils'

class CustomAPIs {
    constructor(config) {
        this.fetch = createCustomFetch(config)
    }

    navigation = async (...args) => {
        return this.fetch('GET', 'navigation/v1', 'navigation', null, args, 'navigation', null)
    }

    navigationHeader = async (...args) => {
        return this.fetch(
            'GET',
            'navigation/v1',
            'navigation-header',
            null,
            args,
            'navigationHeader',
            null
        )
    }

    getProductSetPrices = async (...args) => {
        const required = ['c_selected']

        let requiredParametersError = checkRequiredParameters(args[0], required)
        if (requiredParametersError) {
            return requiredParametersError
        }

        return this.fetch(
            'GET',
            'shopper-productset/v1',
            'get-products',
            args?.[0]?.parameters,
            args,
            'getProductSetPrices',
            null
        )
    }
}

export default CustomAPIs
